import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellSnoozed = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30 28H10V18C10 12.48 14.48 8 20 8C25.52 8 30 12.48 30 18V28Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0001 32C18.3401 32 17.0001 30.66 17.0001 29V28H23.0001V29C23.0001 30.66 21.6601 32 20.0001 32Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.024 14H23.492V15.848L19.808 20.48H23.468V22.4H17V20.552L20.672 15.92H17.024V14Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgBellSnoozed);
export default ForwardRef;
